import { render, staticRenderFns } from "./FooterData.vue?vue&type=template&id=e368227a&"
import script from "./FooterData.vue?vue&type=script&lang=js&"
export * from "./FooterData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports